<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="500"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <!--
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
      -->
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="星级描述" prop="">
          <el-tag
            size="medium"
            :key="tag"
            v-for="tag in form.starList"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新增星级描述</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model.trim="form.text"
            class="fix-width"
            type="textarea"
            placeholder="请输入备注，选填"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createRank, updateRank, } from '@/api/alfmeier'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'AlfmeierRankEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      restaurantList: [],
      branchList: [],
      form: {
        rankId: '',
        branchId: '',
        starList: [],
        title: '',
        text: '',
        order: 1,
      },
      inputVisible: false,
      inputValue: '',
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        starList: [{ required: true, trigger: 'blur', message: '请输入星级描述' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    handleClose(tag) {
      this.form.starList.splice(this.form.starList.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.form.starList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改评价'
        this.form.title = row.title
        this.form.starList = row.basic.starList
        this.form.text = row.basic.text
        this.form.order = row.basic.order
        this.form.branchId = row.extra.branchId
        this.form.rankId = row.rankId
      } else {
        this.title = '新增评价'
      }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const rankId = this.form.rankId
          const data = Object.assign({}, this.form)
          if(data.starList.length != 5){
            return this.$message.warning('星级描述数量不正确')
          }
          this.$baseConfirm(
            `你确定要${rankId ? '修改' : '新增'}评价吗`,
            null,
            async () => {
              rankId ? await updateRank(data) : await createRank(data)
              this.$baseMessage(
                `${rankId ? '修改' : '新增'}评价成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  max-width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.error-color {
  color: #f56c6c;
}
.h2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
